import { EllipsisIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '../clickable'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '../DropdownMenu'

interface RowActionsMenuProps {
  label: string
  children: ReactNode
}

// Clicks stop here so opening the menu never selects or expands the row underneath.
export const RowActionsMenu = ({ label, children }: RowActionsMenuProps) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        theme="ghost"
        size="sm"
        isIcon
        aria-label={label}
        onClick={(event) => event.stopPropagation()}
      >
        <EllipsisIcon className="size-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="end"
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </DropdownMenuContent>
  </DropdownMenu>
)
